import { CommonModule, NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SewWsContentWrapper } from '@sew/ui-components-angular/standalone';
import { PostComponent } from '../../../../components/post/post.component';
import { BlogPost } from '../../../../models/blog-posts.model';

@Component({
    selector: 'blog-tag-articles',
    templateUrl: './tag-articles.component.html',
    styleUrls: ['./tag-articles.component.scss'],
    imports: [CommonModule, PostComponent, NgClass, SewWsContentWrapper],
})
export class TagArticlesComponent {
    @Input() public headline?: string;
    @Input() public filteredTags?: string[];
    @Input() public filteredPosts?: BlogPost[];
    @Input() public breakpoint = 0;

    @Output() public removeTag = new EventEmitter<string>();
    @Output() public addTag = new EventEmitter<string>();
    @Output() public displayArticle = new EventEmitter<BlogPost>();

    public filteredTagClicked(tag: string) {
        this.removeTag.emit(tag);
    }

    public tagClick(tag: string) {
        this.addTag.emit(tag);
    }

    public postClick(post: BlogPost) {
        this.displayArticle.emit(post);
    }

    public getTeaserClass(i: number): string {
        const rest = i % 5;

        if (rest < 2) {
            return 'no-padding span-3';
        } else {
            return 'no-padding span-2';
        }
    }
}
